import React from 'react';
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, ListSubheader, FormHelperText } from '@mui/material';
import { doctorGroups, wardBedOptions } from '../constants/options';

const PatientDemographicsSection = ({ formData, handleChange, handleNameChange, handleBlur, errors }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Patient Name"
          InputProps={{ readOnly: true }}
          name="patient_name"
          fullWidth
          value={formData.patient_name || ''}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label="Age"
          name="age"
          type="number"
          InputProps={{ readOnly: true }}
          fullWidth
          value={formData.age || ''}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          select
          label="Gender"
          name="sex"
          InputProps={{ readOnly: true }}
          value={formData.sex || ''}
          fullWidth
        >
          <MenuItem value="Male">Male</MenuItem>
          <MenuItem value="Female">Female</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth error={!!errors.consultant}>
          <InputLabel id="consultant-label">Consultant <span style={{ color: 'red' }}>*</span></InputLabel>
          <Select
            labelId="consultant-label"
            id="consultant"
            name="consultant"
            value={formData.consultant || ''}
            required
            onChange={handleChange}
            onBlur={handleBlur}
            label={<span>Consultant <span style={{ color: 'red' }}>*</span></span>}
          >
            <MenuItem value=""><em>Select Consultant</em></MenuItem>
            {Object.entries(doctorGroups).map(([specialty, doctors]) => [
              <ListSubheader key={specialty}>{specialty}</ListSubheader>,
              doctors.map((doctor, idx) => (
                <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                  {doctor}
                </MenuItem>
              )),
            ])}
          </Select>
          {errors.consultant && <FormHelperText>{errors.consultant}</FormHelperText>}
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormControl fullWidth>
          <InputLabel id="ward-bed-select-label">Ward & Bed No</InputLabel>
          <Select
            labelId="ward-bed-select-label"
            name="ward_bed_no"
            value={formData.ward_bed_no || ''}
            onChange={handleChange}
            label="Ward & Bed No"
          >
            <MenuItem value=""><em>Select Ward & Bed</em></MenuItem>
            {wardBedOptions.map((option) => (
              <MenuItem key={option} value={option}>{option}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label="IP No"
          name="ip_no"
          value={formData.ip_no || ''}
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <TextField
          label="UHID No"
          name="uhid_no"
          value={formData.uhid_no || ''}
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Grid>
    </Grid>
  );
};

export default PatientDemographicsSection;
